module.exports = __webpack_public_path__ + "static/img/18044B_1_2_R_20211025_LC.abf748c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18044B_1_2_R_20211025_LC.png
// module id = jDvl
// module chunks = 0